'use client';

import React, { useState } from 'react';
import { BetDetailsTab } from '@/app/dashboard/bets/components/bet-details-tab';
import { BetJsonTab } from '@/app/dashboard/bets/components/bet-json-tab';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';
import { Divider, Tab, Tabs, Typography } from '@mui/material';
import { Stack } from '@mui/system';

import { BetTab, GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function BetDetailsDrawer(): React.JSX.Element {
  const { drawerState } = useAppSelector(getUi);
  const dispatch = useAppDispatch();

  const [tabValue, setTabValue] = useState(BetTab.DETAILS);
  const tabList = [
    {
      id: BetTab.DETAILS,
      label: 'Details',
      content: <BetDetailsTab />,
    },
    {
      id: BetTab.JSON,
      label: 'JSON',
      content: <BetJsonTab />,
    },
    {
      id: BetTab.TECH_SUPPORT,
      label: 'Tech Support',
      content: <Typography>Soon</Typography>,
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: BetTab): void => {
    setTabValue(newValue);
  };

  return (
    <DrawerTemplate
      open={drawerState.BET_DETAILS}
      onClose={() => dispatch(hideDrawerState(GeneralDrawer.BET_DETAILS))}
      title="Bet Details"
      width="830px"
    >
      <Tabs value={tabValue} onChange={handleChange}>
        {tabList.map((item) => (
          <Tab key={item.id} label={item.label} value={item.id} />
        ))}
      </Tabs>
      <Divider />
      {tabList.map((item) => (
        <Stack sx={{ pt: 2, display: item.id === tabValue ? 'flex' : 'none' }} key={item.id}>
          {item.content}
        </Stack>
      ))}
    </DrawerTemplate>
  );
}
